(function() {
  'use strict';

  angular
    .module('app.notification')
    .factory('NotificationViewService', NotificationViewService);

  NotificationViewService.$inject = [
    '$state',
    '$rootScope',
    'APP_CONSTANTS',
    'ApiCaller',
    '$window',
    '$stateParams',
    '$q',
    '$filter'
  ];

  function NotificationViewService(
    $state,
    $rootScope,
    APP_CONSTANTS,
    ApiCaller,
    $window,
    $stateParams,
    $q,
    $filter
  ) {
    var self = this;

    self.fetchNotificationDetail = fetchNotificationDetail;

    function fetchNotificationDetail(notificationId) {
      var deferred = $q.defer();
      // TODO: We need to use either mail or message and use it throughout the application.
      var url = $filter('sprintf')(
        APP_CONSTANTS.notificationSingle,
        APP_CONSTANTS.rootUrl,
        notificationId
      );

      ApiCaller.apiGet(url).then(
        function(result) {
          deferred.resolve(result);
        },
        function(err) {
          deferred.reject(err);
        }
      );

      return deferred.promise;
    }

    return self;
  }
})();
